module.exports = __webpack_public_path__ + "static/media/opl2.png.4a39a26f.jpg";